import { render, staticRenderFns } from "./ExaminationFiles.vue?vue&type=template&id=012eea44&scoped=true"
import script from "./ExaminationFiles.vue?vue&type=script&lang=js"
export * from "./ExaminationFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012eea44",
  null
  
)

export default component.exports